/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon20Regular = forwardRef('ShapeTriangleUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.937 3.083c.963-1.506 3.163-1.506 4.127 0l6.493 10.146C19.601 14.86 18.43 17 16.494 17H3.506C1.57 17 .4 14.86 1.443 13.23L7.937 3.083Zm2.863.809a.95.95 0 0 0-1.6 0L2.706 14.038a.95.95 0 0 0 .8 1.462h12.988a.95.95 0 0 0 .8-1.462L10.8 3.892Z" })));
});
